// material-ui

/**
 * if you want to use image instead of <svg> uncomment following.
 *
 * import logoIconDark from 'assets/images/logo-icon-dark.svg';
 * import logoIcon from 'assets/images/logo-icon.svg';
 * import { ThemeMode } from 'config';
 *
 */

// ==============================|| LOGO ICON SVG ||============================== //

export default function LogoIcon() {
  return (
    // <img style={{ height: "100%" }} src="https://d3fb03zx5h21st.cloudfront.net/Upload/Logo/DSU_Small.png" />
    // <img style={{ height: "100%" }} src="https://d3t0f9jpt2fds8.cloudfront.net/Upload/Logo/SMVIT_SmallLogo.png" />
    // <img style={{ height: "100%" }} src="https://d1f11tvnfjqryd.cloudfront.net/Images/ITMBU_Logo.png" />
    // <img style={{ height: "100%" }}  src="https://d1ravyl4xj14l2.cloudfront.net/Upload/Logo/Geetanjali_SmallLogo.png" />
    <img style={{ height: "100%" }} src="https://d39itv4llo32q2.cloudfront.net/Upload/Logo/DDU_SmallLogo.png" />
    // <img style={{ height: "100%" }} src="https://d3a4jls59ro43h.cloudfront.net/Upload/Logo/MEU_SmallLogo.png" />
    // <img style={{ height: "100%" }} src="https://d3nbc713tplvd1.cloudfront.net/Upload/Logo/Rai_SmallLogo.png" />
    // <img style={{ height: "100%" }} src="https://d2beora143tsok.cloudfront.net/Upload/Logo/IU_SmallLogo.png" />
    // <img style={{ height: "100%" }} src="https://d2ocuppja9d4fr.cloudfront.net/Upload/Logo/GN_SmallLogo.png" />
  );
}
